module.exports = __webpack_public_path__ + "assets/pdf/Cycle 2 National ZEV Investment Plan - Public Version vF.50bb1fe0.pdf";